import {
  specialPostsDelete, specialPostsGet, specialPostsPost, specialPostsPut,
} from './specialPostsApi';
import type {
  SpecialPostStatus,
  SpecialPostType,
  SpecialPostTypeCreate,
  SpecialPostTypePage,
  SpecialPostTypeQuery,
  SpecialPostTypeUpdate,
} from '../types/specialPosts';

/** Special post types and their domes (SCRUM-247); every method maps 1:1 to an admin-service route. */
export class SpecialPostsService {
  static list(query: SpecialPostTypeQuery) {
    const params: Record<string, unknown> = { pageNo: query.pageNo, limit: query.limit };
    if (query.search) params.search = query.search;
    if (query.status) params.status = query.status;
    return specialPostsGet<SpecialPostTypePage>('', params);
  }

  static get(id: string) {
    return specialPostsGet<SpecialPostType>(`/${id}`);
  }

  static create(payload: SpecialPostTypeCreate) {
    return specialPostsPost<SpecialPostType>('', payload);
  }

  static update(id: string, payload: SpecialPostTypeUpdate) {
    return specialPostsPut<SpecialPostType>('', { specialPostTypeId: id, ...payload });
  }

  static setStatus(id: string, status: SpecialPostStatus) {
    return specialPostsPut<SpecialPostType>('/status', { specialPostTypeId: id, status });
  }

  static remove(id: string) {
    return specialPostsDelete<Record<string, never>>('', { specialPostTypeId: id });
  }
}
